<template>
  <div>
    <v-dialog v-if="!bModalDescargas" v-model="bShowExport" hide-overlay persistent width="500">
    <v-card
      class="text-center"
      color="primary"
      dark>
      <v-card-text class="text-center pa-1">
        <p class="lh-base pa-2">
          {{ sLabel }}
        </p>
        <div
          v-if="nAvanceGeneral<100"
          style="height: 90px;"
        >
          <fulfilling-bouncing-circle-spinner
            :animation-duration="4000"
            :size="40"
            color='white'
            class="mx-auto"
          />
          <p class="lh-base py-4">
            {{ Math.floor(nAvanceGeneral *100) / 100 }} %
        </p>
          
        </div>
      </v-card-text>
      <!-- <v-btn class="mx-auto my-2"
        @click="CloseDialog"
        color="white"
        outlined
        v-if="nAvanceGeneral >= 100"
      >
        Cerrar
      </v-btn> -->
    </v-card>
    </v-dialog>

    <v-dialog
      v-else
      v-model="bModalDescargas"
      persistent
      max-width="600px"
    >
        <v-card min-height="400px">
        <v-toolbar color="primary" height="45" elevation="0" dense dark>
          <v-spacer></v-spacer>
          <v-btn  color="btncolor-dark" @click="bModalDescargas=false,CloseDialog()" icon small dark outlined>
            <v-icon size="14px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="py-3">
        <v-row class="no-gutters text-center px-4">
          <v-col cols="12" class="text-center  mb-2">
            <span class="font-size-1 text-primary">
              <strong>Rango de exportado: {{aRangoExportarTodo[0]+' al '+aRangoExportarTodo[1]}}</strong>
            </span>
          </v-col>
          <v-col cols="12" class="text-center mb-2">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" class="text-center mb-2">
            <span class="font-size-1 text-black">
              Selecciona el formato que necesitas
            </span>
          </v-col>
          <v-col cols="12" class="mb-4">
            <v-tabs fixed-tabs v-model="nOpcionDescarga">
              <v-tab key="0">EXCEL</v-tab>
              <v-tab key="1">CSV</v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" class="text-justify mb-2">
            <span class="font-size-1 text-black">
              <strong>Puedes descargar uno a uno</strong> los archivos que necesites en el ícono al final de cada archivo o en el botón descargar todos para obtenerlos todos.
            </span>
          </v-col>
          <v-col cols="12" class="text-justify mb-2">
            <span class="font-size-1 text-primary">
              <strong>Archivos generados:</strong>
            </span>
          </v-col>
        </v-row>
        <v-row class="no-gutters px-4 overflow-y-auto" v-if="nOpcionDescarga==0" style="height: 200px !important;">
          <v-col cols="12" class="mt-2" :key="i+'excel'" v-for="(oArchivos,i) in oArchivosDescargar.aExcel">
            <v-hover
              v-slot="{ hover }"
              open-delay="200"
            >
              <v-card
                :elevation="hover ? 16 : 2"
                :class="{ 'on-hover': hover }"
                class="mx-auto"
                style="cursor:pointer"
                @click="onAccederURL(oArchivos.url,oArchivos.nombre)"
              >
                <v-card-text class="font-weight-mediums text-subtitle-1">
                  <v-row>
                    <v-icon size="30px" class="mr-2">mdi-file-document-outline </v-icon>
                    <span class="font-size-1 text-black">{{ oArchivos.nombre }}</span>
                    <v-spacer></v-spacer>
                    <v-icon size="30px" class="mr-2">mdi-download</v-icon>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-row class="no-gutters px-4  overflow-y-auto" v-else style="height: 200px !important;">
          <v-col cols="12" class="mt-1" :key="i+'svc'" v-for="(oArchivos,i) in oArchivosDescargar.aSVC">
            <v-hover
              v-slot="{ hover }"
              open-delay="200"
            >
              <v-card
                :elevation="hover ? 16 : 2"
                :class="{ 'on-hover': hover }"
                class="mx-auto"
                style="cursor:pointer"
                @click="onAccederURL(oArchivos.url,oArchivos.nombre)"
              >
                <v-card-text class="font-weight-mediums text-subtitle-1">
                  <v-row>
                    <v-icon size="30px" class="mr-2">mdi-file-document-outline </v-icon>
                    <span class="font-size-1 text-black">{{ oArchivos.nombre }}</span>
                    <v-spacer></v-spacer>
                    <v-icon size="30px" class="mr-2">mdi-download</v-icon>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-row class="no-gutters px-4 py-4">
          <v-col cols="12" class="mt-1 d-flex flex-row-reverse">
            <v-btn color="primary" @click="onDescargarTodo">DESCARGAR TODO<v-icon right dark>mdi-download</v-icon></v-btn>
          </v-col>
        </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import XLSX from 'xlsx'
import axiosServices from '@/services/axiosServices.js'
import axios from 'axios'
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'

// import Hora from '@/Utilidades/Hora_Fecha.js'
var asyncLoop = require('node-async-loop')
export default {
  name: 'ExportExcel',
  components: {
    FulfillingBouncingCircleSpinner
  },
  props: {
    bShowExport: {            // Si se activa el boton exportar
      type: Boolean,
      default: false
    },
    TypeExport: {             // Indica el formato dearchivo a exportar
      type: String,
      default: 'xlsx'
    },
    sTable: {                 // Tabla principal a exportar
      type: String,
      default: ''
    },
    oFiltro: {                // El filtro activo para la exportacion
      type: Object,
      default: () => {}
    },
    nPage: {                  // No Pargina para cuando se requiere exportar actual
      type: Number,
      default: 1
    },
    nPerPage: {               // No de registros por pagina cuando se requier exportar actual
      type: Number,
      default: 5
    },
    aInfoTBDetalleExp: {      // arreglo donde vienen la informacón de la las tablas detalles
      type: Array,
      default: () => []
    },
    bSubdominioTemporal:{ //Indica que se activa puente con subdominio temporal
      type: Boolean,
      default: false
    },
    aRangoExportarTodo:{      // arreglo con el rango de fechas a exportar máximo 6 meses
      type: Array,
      default: () => []
    },
    sIdTable: {                // nombre del pimary key de la tabla para ver los detalles - Si son mas de una se deben separar por comas "," siempre se debe poner el nombre real del campo
      type: String,
      default: ''
    },
  },
  data() {
    return {
      json_meta   : [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      aHeaders: [],
      aItems: [],
      sLabel : '',
      bFinish: true,
      nameArchive: '',
      nAvanceGeneral: 0.0,
      nAvancePaso: 0.0,
      nAvancePasoDetalle: 0.0,
      nAvancePasoDetalleVuelta: 0.0,
      sNombreArchivo: '',
      nVueltasPrincipal: 0,
      bModalDescargas:false,
      oArchivosDescargar:{
        aExcel:[],
        aSVC:[],
      },
      nOpcionDescarga:0
    }
  },
  methods: {
    async getDataExport() {
      this.nAvanceGeneral = 0
      let sParamsExport = this.onParametrosSolicitud() 
      this.sLabel = this.$store.state.jsIdioma.oEquivalencias.msgExportandoGrid;
      if(this.bSubdominioTemporal){
        sParamsExport = sParamsExport + `&subdominiot=${this.$store.state.sSubdominioTemporal}`
      }
      const oRespuesta = await axiosServices.getConfiguration('/dataExport/registros', true, sParamsExport)
      await this.sleep(2 * 1000);
      this.nVueltasPrincipal = oRespuesta.aData.aVueltas.length
      this.nAvancePaso = 100 / parseInt(oRespuesta.aData.aVueltas.length +1)
      this.sNombreArchivo = oRespuesta.aData.NombreProceso
      if(oRespuesta.aData.aVueltas.length ===0) {
        this.nAvanceGeneral = 100
        this.sLabel = this.$store.state.jsIdioma.oEquivalencias.msgExportacionNoFechas;
      } else {
        asyncLoop(oRespuesta.aData.aVueltas, this.onProcesarVueltas);
      }
    
    },
    async onObtenerUrl () {
      let sParamsExport = this.onParametrosSolicitud() 
      if(this.bSubdominioTemporal){
        sParamsExport = sParamsExport + `&subdominiot=${this.$store.state.sSubdominioTemporal}`
      }
      sParamsExport = sParamsExport + `&sNombreProceso=${this.sNombreArchivo}&bLogs`
      const oRespuesta = await axiosServices.getConfiguration('/dataExport/generar_url', true, sParamsExport)
      this.nAvanceGeneral= 100
      this.sLabel = this.$store.state.jsIdioma.oEquivalencias.msgExportacionArchivo;
      this.oArchivosDescargar = oRespuesta.aData;
      

    },
    async onProcesarVueltas(nVuelta, next) {
      this.sLabel = this.$store.state.jsIdioma.oEquivalencias.msgExportacionAvancePrincipal.replace('XXXX',nVuelta).replace('YYYY', this.nVueltasPrincipal)

      let sParamsExport = this.onParametrosSolicitud() 
      if(this.bSubdominioTemporal){
        sParamsExport = sParamsExport + `&subdominiot=${this.$store.state.sSubdominioTemporal}`
      }
      sParamsExport = sParamsExport + `&nPagina=${nVuelta}&sNombreProceso=${this.sNombreArchivo}&bLogs`
      const oRespuesta = await axiosServices.getConfiguration('/dataExport', true, sParamsExport)
      await this.sleep(2 * 1000);

      if (oRespuesta.nStatusCode === 200) {
        //Verificamos detalle 
        if (this.aInfoTBDetalleExp.length === 0) {
          this.nAvanceGeneral= this.nAvanceGeneral+ this.nAvancePaso
          if(this.nVueltasPrincipal === 1) this.onObtenerUrl()
          next()
        } else {
          this.nAvancePasoDetalle = this.nAvancePaso / this.aInfoTBDetalleExp.length
          const aInfoDetalle = oRespuesta.aData.aInfoDetalle;
          var pDetalle = new Promise((resolveP) => {
            asyncLoop(aInfoDetalle, async (oItem, nextDetalle) => {
              this.nAvancePasoDetalleVuelta = this.nAvancePasoDetalle / oItem.aVueltas.length

              var pDetalleVuelta = new Promise((resolve, reject) => {
                if(oItem.aVueltas.length === 0) {
                  resolve(true)
                }else{
                  asyncLoop(oItem.aVueltas, async (nVueltaDetalle, nextDetalleVuelta) => {

                    sParamsExport = `&nPagina=${nVueltaDetalle}&sNombreProceso=${this.sNombreArchivo}&bLogs&bDetalle&oDetalle=${JSON.stringify(oItem)}`
                    const oRespuestaDetalle = await axiosServices.getConfiguration('/dataExport', true, sParamsExport)
                    await this.sleep(2 * 1000);


                    if(oRespuestaDetalle.nStatusCode !== 200) {
                      reject()
                    }

                    nextDetalleVuelta()
                    this.nAvanceGeneral= this.nAvanceGeneral+ this.nAvancePasoDetalleVuelta
                    this.sLabel = this.$store.state.jsIdioma.oEquivalencias.msgExportacionAvanceDetalle.replace('ZZZZ',oItem.nIndice).replace('XXXX',nVueltaDetalle).replace('YYYY', oItem.aVueltas.length)

                    if(nVueltaDetalle === oItem.aVueltas.length) resolve(true)
                  })
                }
              })
              pDetalleVuelta.then(() => {
                if(aInfoDetalle[aInfoDetalle.length-1] === oItem) {
                  resolveP(true)
                }
                nextDetalle()
              })
            })
          })
          pDetalle.then(()=>{
            if(this.nVueltasPrincipal === nVuelta) this.onObtenerUrl()
            next()
          })

          
        }
      }
      
      
    }, 
    onParametrosSolicitud() {
      const aFiltro = (Object.keys(this.oFiltro).length === 0) ? "" : `&filtros=${JSON.stringify(this.oFiltro)}`
      const aDetalles = (this.aInfoTBDetalleExp.length === 0) ? [] : `${JSON.stringify(this.aInfoTBDetalleExp)}`
      
      return `sTable=${this.sTable}${aFiltro}&sNombrePrimaryKey=${this.sIdTable}&aDetalles=${aDetalles}` +
      `&sFechaIniExport=${this.aRangoExportarTodo[0]}&sFechaFinExport=${this.aRangoExportarTodo[1]}`
      
    },
    CloseDialog() {
      this.$emit('input', false)
    },
    onExport () { // On Click Excel download button  Se deja comento por si se requier a futubo como ejemplo 
      // // export json to Worksheet of Excel
      // // only array possible
      // var Sheet = XLSX.utils.json_to_sheet(this.aItems, {header: this.aHeaders})
      // // A workbook is the name given to an Excel file
      // var wb = XLSX.utils.book_new() // make Workbook of Excel
      // // add Worksheet to Workbook
      // // Workbook contains one or more worksheets
      // XLSX.utils.book_append_sheet(wb, Sheet, this.nameArchive)// sheetAName is name of Worksheet
      // // export Excel file
      // XLSX.writeFile(wb, `${this.nameArchive}.${this.TypeExport}`) // name of the file
      // this.CloseDialog()
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async onAccederURL(sUrl,sNombreArchivo){
      axios({
            url: sUrl, // File URL Goes Here
            method: 'GET',
            responseType: 'blob',
      }).then((res) => {

            var FILE = window.URL.createObjectURL(new Blob([res.data]));
            
            var docUrl = document.createElement('a');
            docUrl.href = FILE;
            docUrl.setAttribute('download', sNombreArchivo);
            document.body.appendChild(docUrl);
            docUrl.click();
      });
    },
    onDescargarTodo(){
      if(this.nOpcionDescarga==0){
        this.oArchivosDescargar.aExcel.forEach(oArchivo => {
          this.onAccederURL(oArchivo.url,oArchivo.nombre);
        });
      }
      else{
        this.oArchivosDescargar.aSVC.forEach(oArchivo => {
          this.onAccederURL(oArchivo.url,oArchivo.nombre);
        });
      }
    }
  },
  watch: {
    bShowExport(bNewValue) {
      if (bNewValue == true) {
        this.getDataExport();
        this.nameArchive = `${this.sTable}`;
        this.bFinish = true;
      }
    },
    nAvanceGeneral(){
      if(this.nAvanceGeneral>=100){
        this.bModalDescargas=true;
      }
    },
    aRangoExportarTodo(){
    }
  }
}
</script>
